export default __webpack_public_path__ + "static/media/logo-white.fcd64c7d.svg";